import { Icons } from '@/components/icons';
import { cn } from '@/lib/cn';
import { CheckIcon, XMarkIcon } from '@heroicons/react/16/solid';
import { motion } from 'framer-motion';

export default function NotificationIndicator({
  count,
  className,
  noCheck,
  noZero,
  error,
  variant = 'action',
}: {
  count?: number | string | boolean;
  className?: string;
  noCheck?: boolean;
  noZero?: boolean;
  error?: boolean;
  variant?: 'action' | 'info';
}) {
  const isInfo = variant === 'info';
  const hideZero = noZero || isInfo;
  const hideCheck = noCheck || isInfo;

  if (error)
    return (
      <div
        className={cn(
          'ml-auto rounded-full bg-destructive-subtle px-2 text-xs text-destructive',
          className
        )}
      >
        <XMarkIcon className='size-4' />
      </div>
    );
  if (count == 0 && hideZero) return null;

  if (count == 0 && !hideCheck) {
    return (
      <div
        className={cn(
          'ml-auto rounded-full bg-success-subtle px-2 py-px text-xs text-success',
          className
        )}
      >
        <CheckIcon className='size-4' />
      </div>
    );
  }
  return (
    <motion.div
      key={`count`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={cn(
        'ml-auto flex min-w-[32px] items-center justify-center rounded-full px-2 py-px text-xs',
        isInfo
          ? 'bg-subtle text-muted-foreground'
          : 'bg-primary text-primary-foreground',
        className
      )}
    >
      {count === true ? (
        <Icons.loader className='size-4 animate-spin' />
      ) : (
        <motion.div
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {count}
        </motion.div>
      )}
    </motion.div>
  );
}
